import axios from 'axios'
import { Modal } from 'view-design'

export const isNewVersion = () => {
  const url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`

  axios.get(url).then(res => {
    if (res.status === 200) {
      const currentVersion = res.data.version || '1.0.0'

      const localVueVersion = localStorage.getItem('projectVersion')

      localStorage.setItem('projectVersion', currentVersion)

      if (localVueVersion && localVueVersion !== currentVersion) {
        Modal.confirm({
          title: '已发现新版本',
          content: '<p>是否需要更新到最新版本？</p>',
          cancelText: '稍后手动更新',
          onOk: () => {
            window.location.reload(true)
          },
          onCancel: () => {
            this.$Message.info('Clicked cancel')
          }
        })
      }
    }
  })
}
export const checkProjectVersion = function () {
  const VUE_APP_VERSION = require('../../package.json').version
  console.log('VUE_APP_VERSION', VUE_APP_VERSION)
  const vers = window.localStorage.getItem('lawyerAppVersion')
  if (VUE_APP_VERSION !== vers) {
    console.log('刷新')
    window.localStorage.setItem('lawyerAppVersion', VUE_APP_VERSION)
    location.reload()
  }
}



// WEBPACK FOOTER //
// ./src/libs/check-project-version.js